module.exports = __webpack_public_path__ + "assets/ic-milk-token.59b4b20e.svg";